import { Flex, Heading, SimpleGrid } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import { borderVariant13 } from '../../../../chakraTheme'
import { LOGIN, REGISTER } from '../enums/authMode'

const Tab = ({ isActive, children, onClick }) => {
    return (
        <Flex
            flexGrow={1}
            justifyContent="center"
            alignItems="center"
            borderBottom={
                isActive ? '3px solid var(--chakra-colors-rum)' : 'none'
            }
            pt={5}
            pb={isActive ? 4 : '19px'}
            cursor={isActive ? '' : 'pointer'}
            onClick={() => {
                !isActive && onClick()
            }}
            bgColor={isActive ? 'athensgray' : 'white'}
            color={isActive ? 'rum' : 'scorpion'}
            borderLeft={borderVariant13}
            borderTop={borderVariant13}
            _last={{
                borderRight: borderVariant13,
            }}
        >
            {children}
        </Flex>
    )
}

const AuthTabs = ({ activeTab = LOGIN, basePath = '' }) => {
    const navigate = useNavigate()

    return (
        <SimpleGrid borderBottom={borderVariant13} flexGrow={1} columns={2}>
            <Tab
                isActive={activeTab === REGISTER}
                onClick={() => {
                    navigate(`${basePath}/register`)
                }}
            >
                <Heading
                    fontSize={'md'}
                    as="h6"
                    fontWeight={activeTab === REGISTER ? 700 : 500}
                >
                    Register
                </Heading>
            </Tab>
            <Tab
                isActive={activeTab === LOGIN}
                onClick={() => {
                    navigate(`${basePath}/login`)
                }}
            >
                <Heading
                    fontSize={'md'}
                    as="h6"
                    fontWeight={activeTab === LOGIN ? 700 : 500}
                >
                    Login
                </Heading>
            </Tab>
        </SimpleGrid>
    )
}

export default AuthTabs
